import { render, staticRenderFns } from "./information.vue?vue&type=template&id=7c508d9e&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=7c508d9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c508d9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c508d9e')) {
      api.createRecord('7c508d9e', component.options)
    } else {
      api.reload('7c508d9e', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=7c508d9e&scoped=true", function () {
      api.rerender('7c508d9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customers/information.vue"
export default component.exports